(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-dom"), require("immutable"), require("react-redux"), require("redux"), require("@fiverr/globals"), require("react"), require("redux-thunk"));
	else if(typeof define === 'function' && define.amd)
		define(["react-dom", "immutable", "react-redux", "redux", "@fiverr/globals", "react", "redux-thunk"], factory);
	else if(typeof exports === 'object')
		exports["Reviews"] = factory(require("react-dom"), require("immutable"), require("react-redux"), require("redux"), require("@fiverr/globals"), require("react"), require("redux-thunk"));
	else
		root["Reviews"] = factory(root["ReactDOM"], root["Immutable"], root["ReactRedux"], root["Redux"], root["@fiverr/globals"], root["React"], root["ReduxThunk"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_wLXD__, __WEBPACK_EXTERNAL_MODULE_gNLg__, __WEBPACK_EXTERNAL_MODULE_H_qB__, __WEBPACK_EXTERNAL_MODULE_dJD___, __WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_SHgP__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition